/* eslint-disable no-mixed-spaces-and-tabs */
import { React, useMemo } from 'react';
import { AuthenticatedPageLayout } from '@/components/layouts/AuthenticatedPageLayout';
import { EmailView } from '@/components/views/EmailView';

export const TemplatesPage = () => {
	return (
		<AuthenticatedPageLayout>
			<EmailView />
		</AuthenticatedPageLayout>
	);
};
